import {
  CardWithIcon,
  Heading,
  SvgIconProps,
  Text,
} from '@cinch-labs/design-system'

import styles from './feature-card.module.css'
import { IconNames } from '@cinch-labs/design-system/dist/src/tokens/tokens.types'

export interface FeatureCardProps {
  title: string
  body: string
  icon: SvgIconProps['name']
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  body,
  icon,
}) => (
  <div className={styles.card} data-testid="feature-card">
    <CardWithIcon
      className={styles['iconContainer']}
      iconName={icon as IconNames}
      iconColor="vividViolet"
      iconGradient="galaxy"
      iconSize={32}
    />
    <Heading element="h3" className={styles.title}>
      {title}
    </Heading>
    <Text className={styles.body}>{body}</Text>
  </div>
)
